var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 28,
    height: 28,
    rx: 14,
    fill: "white",
    stroke: "#CCCCCC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0769 14.8398L20.0717 13.9658C20.0717 13.7279 19.8752 13.5313 19.6321 13.5262L15.2464 13.5261L15.2464 9.05772C15.2464 8.81971 15.0499 8.62318 14.8068 8.61811L13.9276 8.61811C13.6896 8.61806 13.4931 8.81459 13.488 9.05772L13.488 13.5158L9.10228 13.5262C8.86437 13.5262 8.66784 13.7227 8.66267 13.9658L8.66268 14.845C8.66268 15.0829 8.85921 15.2794 9.10228 15.2846L13.488 15.2846L13.488 19.6703C13.488 19.9082 13.6845 20.1047 13.9276 20.1099L14.8068 20.1099C15.0447 20.1099 15.2412 19.9134 15.2464 19.6703L15.2412 15.2794L19.6269 15.2795C19.8752 15.2794 20.0718 15.0828 20.0769 14.8398Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.459ba6ed371f3a2341cd20789084f3e6.svg";
export { ForwardRef as ReactComponent };